import { render, staticRenderFns } from "./edition1.vue?vue&type=template&id=509a6dd7&"
import script from "./edition1.vue?vue&type=script&lang=js&"
export * from "./edition1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports